import React from 'react';
import { type FieldValues, type Path, useController, type UseControllerProps } from 'react-hook-form';

import { RadioGroupField } from '#/shared/components/FormField';

type RadioGroupFieldProps = Omit<
  React.ComponentProps<typeof RadioGroupField>,
  'ref' | 'disabled' | 'required' | 'value' | 'defaultValue' | 'onChange' | 'onBlur'
>;

type FormControlRadioGroupProps<
  TFieldValues extends FieldValues,
  TName extends Path<TFieldValues>,
> = UseControllerProps<TFieldValues, TName>;

export function FormControlRadioGroup<TFieldValues extends FieldValues, TName extends Path<TFieldValues>>({
  name,
  control,
  rules,
  defaultValue,
  disabled,
  ...props
}: FormControlRadioGroupProps<TFieldValues, TName> & RadioGroupFieldProps) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    disabled,
  });
  return <RadioGroupField {...props} {...field} errorMessage={fieldState.error?.message} />;
}
